import axios from 'axios';

export const retrying = (
  fn,
  { retries = 3, delay = 1000, retryStatuses = [404] },
) => {
  let retryCount = 0;
  const retry = async (...args) => {
    try {
      const result = await fn(...args);
      retryCount = 0;
      return result;
    } catch (e) {
      retryCount++;
      if (axios.isAxiosError(e)) {
        const matchStatus =
          retryStatuses.indexOf(e.response?.status || -1) >= 0;
        const tryAgain = retryCount <= retries;
        if (matchStatus && tryAgain) {
          return new Promise((resolve, reject) =>
            setTimeout(
              () =>
                retry(...args)
                  .then(a => resolve(a))
                  .catch(e => reject(e)),
              delay,
            ),
          );
        }
      }
      retryCount = 0;
      throw e;
    }
  };
  return retry;
};

export const getPhotoIdField = analysisType => {
  switch (analysisType) {
    case 'BODY_CONDITION':
      return 'weight_photo_id';
    case 'DENTAL':
      return 'dental_photo_id';
    default:
      return 'stool_photo_id';
  }
};

export const getSlugFromAnalysisType = analysisType => {
  if (!analysisType) return '';
  switch (analysisType) {
    case 'BODY_CONDITION':
      return 'weight';
    case 'DENTAL':
      return 'dental';
    case 'STOOL':
      return 'digestion';
    default:
      return 'digestion';
  }
};

export const snakeToPascal = string => {
  return string
    ? string
        .split('_')
        .map(word => capitalize(word))
        .join('')
    : '';
};

export const capitalize = string => {
  return string
    ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    : '';
};
